import React from 'react'
import Table from '../../../../../common/components/table'


 
export default function WebsitePageLayoutComponent ({setPageData,paginationData,additionButtons,rowData,columnDefs,onEdit}: any) {
 
  return (
    <>

<Table
    columnData={columnDefs}
    rowData={rowData}
    onEdit={onEdit}
    additionButtons={additionButtons}
    paginationData={paginationData}
    setPageData={setPageData}
    headingName="Layouts"
    />
                           
                     
   
        </>
  )
}